import { render, staticRenderFns } from "./IngredientEdit.vue?vue&type=template&id=2935959c&"
import script from "./IngredientEdit.vue?vue&type=script&lang=js&"
export * from "./IngredientEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IngredientEdit.vue"
export default component.exports